import type { AxiosResponse } from 'axios';
import type { GetTranscriptTagsOverview } from '@trinity/chat/api/interfaces/transcripts';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';
import { type UseQueryOptions, useQueryWrapper } from '@trinity/chat-components/hooks/useQueryWrapper';

type Data = GetTranscriptTagsOverview.Response;
type Params = ITranscriptId;
type QueryKey = readonly [string, Params];

type Options = Omit<UseQueryOptions<Data, AxiosResponse, Data, QueryKey>, 'queryKey' | 'queryFn'>;

export function useTranscriptTagsOverview(
  data: Params,
  options?: Options,
) {

  const apiClient = useChatApiClient();

  return useQueryWrapper({
    queryKey: ['transcript-tag-overview', data] as const,
    queryFn: ({ queryKey }) => {
      const [, { transcriptId }] = queryKey;

      return apiClient.transcripts.getTranscriptTagsOverview({ transcriptId });

    },
    ...options,
  });
}